var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import MainLayout from '@/components/layout/MainLayout';
import { PidCmsRoutes } from '@/modules/pid-cms/routes/PidCmsRoutes';
import { MobilityConsoleRoutes } from '@/modules/mobility-console/routes/MobilityConsoleRoutes';
import { Navigate } from 'react-router-dom';
var MainRoutes = function (isAuthenticated, userInfo) {
    return {
        path: '/',
        element: isAuthenticated === null || userInfo ? (_jsx(MainLayout, {})) : (_jsx(Navigate, { to: '/login', replace: true })),
        children: __spreadArray(__spreadArray([], MobilityConsoleRoutes, true), PidCmsRoutes, true),
    };
};
export default MainRoutes;
